import Vue from 'vue'

export default class RadioCell {
  init (params) {
    this.eGridCell = params.eGridCell
    let checked = false
    if (params.api.context.parentComponents && params.api.context.parentComponents.selectedValue) {
      checked = params.api.context.parentComponents.selectedValue['empNo'] === params.value
    }
    const InitComp = Vue.component('g-radio')
    this.radioComp = new InitComp({
      propsData: {
        value: params.value,
        checked: checked
      }
    }).$mount()

    this.radioComp.$el.querySelector('input').name = "cell-data"
    this.radioComp.$el.classList.add('-mt-1')

    this.eGui = this.radioComp.$mount()

    this.addEventListener = function(e) {
      params.colDef.onChecked(params.node.data)
    }

    this.eGui.$el.addEventListener('change', this.addEventListener)
  }

  getGui () {
    this.eGridCell.appendChild(this.eGui.$el)
  }

  destory () {
    this.eGui.$el.removeEventListener('change', this.addEventListener)
    this.eGui.$el.parentNode.removeChild(this.eGui.$el)
  }

  refresh (params) {
    this.eGui.$props = {}
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/RadioCell.js